/**
 * Created by KryQ on 2017-06-28.
 */
import React, { Component } from 'react';
import { Col } from 'reactstrap';
import cx from 'classnames';
import L from 'leaflet';
import { Map, TileLayer, Marker, Popup } from 'react-leaflet'


const DEFAULT_VIEWPORT = {
    center: [54.3475, 18.6373],
    zoom: 11
};

let myIcon = L.icon({
    iconUrl: 'marker.png',
    iconSize: [25, 41],
    iconAnchor: [13, 41],
    popupAnchor: [0, -41]
});

export default class GeneralPane extends Component {
    constructor(props) {
        super(props);

        this.state = {
            lat: 54.3475,
            lng: 18.6373,
            zoom: 13,
            isOpen: false,
            viewport: DEFAULT_VIEWPORT,
            trapsLoaded: true,
            trapsData: [],
        };

        this.update = this.update.bind(this);
    }

    componentDidMount () {
        this.update();
    }

    update() {
        fetch(this.props.restIp+'/traps')
            .then(function(response) {
                return response.json()
            })
            .then(function(json) {
                this.setState({
                    trapsLoaded: true,
                    trapsData: json,
                });
            }.bind(this)).catch(function(ex) {
            console.log('parsing failed', ex)
        });
    }

    render() {
        let classes = {
            'hidden': !this.props.visible,
            //'animated zoomInRight': this.props.visible
        };
        let modal_classes = cx(classes);

        let rows = [];
        
        if(this.state.trapsLoaded) {
            this.state.trapsData.forEach((trap) => {
                rows.push(<Marker position={[trap.latitude, trap.longtitude]} icon={myIcon} onClick={() => this.props.selectTrap(trap.id)}>
                    <Popup>
                        <span>{trap.id} - {trap.title}</span>
                    </Popup>
                </Marker>);
            });
        }

        return (
            <Col className={modal_classes} id="general_pane" md="10">
                    <Map
                        viewport={this.state.viewport}
                        style={{width: '100%', height: '100%'}}>
                        <TileLayer
                            attribution="&amp;copy <a href=&quot;http://osm.org/copyright&quot;>OpenStreetMapContainer</a> contributors"
                            url="http://{s}.tile.osm.org/{z}/{x}/{y}.png"
                        />
                        {rows}
                    </Map>
            </Col>
        )
    }
}


// WEBPACK FOOTER //
// ./src/components/GeneralPane.js